module.exports = __webpack_public_path__ + "img/Eleven_Tickets_Positivo_Horizontal.94170e2e.svg";